import { detectInitialLanguage } from "../i18n";

/** Dil değişince `document.title` / SEO güncellemesi için (PublicDataProvider dinler). */
export const PUBLIC_LANGUAGE_CHANGE_EVENT = "dekosta-public-language-changed";

/** Tarayıcıda geçerli public dil — `LanguageContext` ile aynı kurallar (localStorage + tarayıcı). */
export function getStoredPublicLanguage() {
  return detectInitialLanguage();
}

/**
 * CMS satırı: TR = legacy veya tr override; EN = en veya TR fallback.
 * @param {'tr'|'en'} lang
 * @param {{ en?: string | null; tr?: string | null; legacy?: string | null }} opts
 */
export function pickCmsLine(lang, { en, tr, legacy }) {
  const legacyStr = legacy != null ? String(legacy) : "";
  const trShow = tr != null && String(tr).trim() !== "" ? String(tr).trim() : legacyStr;
  const enShow = en != null && String(en).trim() !== "" ? String(en).trim() : trShow;
  return lang === "en" ? enShow : trShow;
}

/** Ayarlardan gelen hero/SEO: EN alanı yoksa legacy (genelde TR). */
export function pickLocalizedSetting(lang, legacyTr, enOptional) {
  const base = legacyTr != null ? String(legacyTr) : "";
  if (lang !== "en") return base;
  return enOptional != null && String(enOptional).trim() !== "" ? String(enOptional).trim() : base;
}

/** Metrik satırı: { k, v, v_en? } */
export function pickMetricValue(lang, metric) {
  if (!metric) return "";
  if (lang === "en" && metric.v_en != null && String(metric.v_en).trim() !== "") return String(metric.v_en).trim();
  return metric.v != null ? String(metric.v) : "";
}

export function pickServiceDisplay(item, lang) {
  return {
    title: pickCmsLine(lang, { en: item.title_en, tr: item.title_tr, legacy: item.title }),
    desc: pickCmsLine(lang, { en: item.description_en, tr: item.description_tr, legacy: item.desc }),
  };
}

export function pickMaterialDisplay(item, lang) {
  return {
    name: pickCmsLine(lang, { en: item.title_en, tr: item.title_tr, legacy: item.name }),
    desc: pickCmsLine(lang, { en: item.description_en, tr: item.description_tr, legacy: item.desc }),
  };
}

export function pickFaqDisplay(item, lang) {
  return {
    q: pickCmsLine(lang, { en: item.title_en, tr: item.title_tr, legacy: item.q }),
    a: pickCmsLine(lang, { en: item.description_en, tr: item.description_tr, legacy: item.a }),
  };
}

export function pickPortfolioTitle(item, lang) {
  return pickCmsLine(lang, { en: item.title_en, tr: item.title_tr, legacy: item.title });
}
